import styled from 'styled-components';
import LoginBtn from './LoginBtn';
import { device } from "../device";

const LogoutBtn = styled(LoginBtn)`
    background: transparent;
    border: 1px solid var(--brand);
    color: var(--brand);
    &:hover {
        background: var(--brand);
        color: #fff;
    }
    @media ${device.lg} {
        .dark & {
            background: transparent;
            border-color: #fff;
            color: #fff;
            &:hover {
                background: #fff;
                color: var(--brand);
            }
        }
    }
`;

export default LogoutBtn;